import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { MultiTenantOrganizationActions } from '../../domains/multiTenantOrganization/actions.types';
import type { MultiTenantOrganizationLifecycle } from '../types';

const initialState: MultiTenantOrganizationLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<MultiTenantOrganizationLifecycle, MultiTenantOrganizationActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'MULTI_TENANT_ORGANIZATION.LOAD_PENDING':
      return setPending();
    case 'MULTI_TENANT_ORGANIZATION.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities?.multiTenantOrganization);
    case 'MULTI_TENANT_ORGANIZATION.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
